import { founders, leadership, operations } from './team';
import { offices, services, segments } from './content';

// Single editing point for ALL public metrics. Only approved brief figures or
// counts of published directories are enabled. No fabricated performance claims.
export const metrics = {
  countries: { value: new Set(offices.map(o => o.code)).size, label: 'Countries served', source: 'Published office directory' },
  pillars: { value: services.length, label: 'Service pillars', source: 'Published service directory' },
  partners: { value: 60, suffix: '+', label: 'Tech partners', source: 'Company-provided original brief' },
  team: { value: founders.length + leadership.length + operations.length, label: 'Team members', detail: 'Across leadership & delivery', source: 'Published team directory' },
  practices: { value: services.reduce((n, s) => n + s.groups.length, 0), label: 'Specialist practices', detail: 'Connected expertise', source: 'Published capability directory' },
  offices: { value: offices.length, label: 'Global offices', detail: 'Local insight. Worldwide reach.', source: 'Published office directory' },
  segments: { value: segments.length, label: 'Business segments', source: 'Published engagement models' },
  // To publish a business metric, supply its real value and add its key to impactKeys.
  // Null values are always visibly marked as awaiting verified company data.
  customers: { value: null, suffix: '+', label: 'Customers served', placeholder: true },
  projects: { value: null, suffix: '+', label: 'Projects delivered', placeholder: true },
  sla: { value: null, suffix: '%', label: 'SLA commitment', placeholder: true },
  experience: { value: null, suffix: '+', label: 'Years of experience', placeholder: true },
  support: { value: null, label: 'Support availability', placeholder: true },
};

export const metricsConfig = {
  heading: 'Measurable Results. Real Business Impact.',
  supportingText: 'We combine technology, strategy, and execution to create measurable value for businesses.',
  impactKeys: ['team', 'practices', 'offices'],
  heroKeys: ['countries', 'pillars', 'partners'],
  aboutKeys: ['offices', 'segments', 'partners'],
};

export const metricDisplay = metric => metric.value == null ? '—' : `${metric.value}${metric.suffix || ''}`;
export const statItems = keys => keys.map(key => [metricDisplay(metrics[key]), metrics[key].label]);